module.exports = __webpack_public_path__ + "img/172.quality_of_the_food.73e84dff.svg";